<template>
    <div class="month-grid">
<!--        <h1 v-text="month" />-->
<!--        <pre>{{ myDays }}</pre>-->
<!--        <pre>{{ calDays }}</pre>-->
<!--        <pre>{{ weeks }}</pre>-->
<!--        <pre>{{ days }}</pre>-->
<!--        <pre>{{ mode }}</pre>-->

<!--        <div class="month" :class="monthClasses">-->
<!--            <div class="month-label" v-text="monthLabel" />-->
<!--            <div class="day-label">Sun</div>-->
<!--            <div class="day-label">Mon</div>-->
<!--            <div class="day-label">Tue</div>-->
<!--            <div class="day-label">Wed</div>-->
<!--            <div class="day-label">Thu</div>-->
<!--            <div class="day-label">Fri</div>-->
<!--            <div class="day-label">Sat</div>-->
<!--            <template v-for="day in calDays">-->
<!--                <month-grid-day-->
<!--                    v-if="day"-->
<!--                    :day="day"-->
<!--                    :mode="mode"-->
<!--                    :date-in="dateIn"-->
<!--                    :date-out="dateOut"-->
<!--                    :hover-day="hoverDay"-->
<!--                    @mouseenter="$emit('hover', day.date)"-->
<!--                    @mouseleave="$emit('hover', null)"-->
<!--                    @check-in="$emit('check-in', day.date)"-->
<!--                    @check-out="$emit('check-out', day.date)"-->
<!--                />-->
<!--                <div-->
<!--                    v-else-->
<!--                    class="day"-->
<!--                />-->
<!--            </template>-->
<!--        </div>-->
<!--        <button v-text="'refresh'" @click="forceUpdate" />-->
        <table class="month" :class="monthClasses">
            <thead>
            <tr>
                <td class="prev-month">
                    <i
                        v-if="showPrevMonthButton"
                        class="fas fa-angle-double-left"
                        @click="$emit('go-prev-month')"
                    />
                </td>
                <td colspan="5" class="month-label" v-text="monthLabel" />
                <td class="next-month">
                    <i
                        v-if="showNextMonthButton"
                        class="fas fa-angle-double-right"
                        @click="$emit('go-next-month')"
                    />
                </td>
            </tr>
            <tr>
                <td class="day-label" v-text="'Sun'" />
                <td class="day-label" v-text="'Mon'" />
                <td class="day-label" v-text="'Tue'" />
                <td class="day-label" v-text="'Wed'" />
                <td class="day-label" v-text="'Thu'" />
                <td class="day-label" v-text="'Fri'" />
                <td class="day-label" v-text="'Sat'" />
            </tr>
            </thead>

            <tbody>
            <tr v-for="week in weeks">
                <td colspan="7">
                    <div style="display: flex;">
                <template v-for="day in week">
<!--                    <td v-if="day">{{ day.date }}: {{ day.fits_a_block }}</td>-->
                    <month-grid-day
                        v-if="day"
                        :key="day.date"
                        :ref="'day-' + day.date"
                        :day="day"
                        :yesterday="yesterday(day.date)"
                        :tomorrow="tomorrow(day.date)"
                        :mode="mode"
                        :date-in="dateIn"
                        :date-out="dateOut"
                        :hover-day="hoverDay"
                        @check-in="$emit('check-in', day.date)"
                        @check-out="$emit('check-out', day.date)"
                    />
<!--                    :ref="'day-' + day.date"-->
                    <!--                    @mouseenter="$emit('hover', day.date)"-->
                    <!--                    @mouseleave="$emit('hover', null)"-->
                    <div
                        v-else
                        class="day"
                        v-html="`&nbsp;`"
                    />
                </template>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import chunk from 'lodash.chunk';
import keyby from 'lodash.keyby';
import MonthGridDay from './MonthGridDay.vue';

dayjs.extend(isBetween);

export default {
    components: {
        MonthGridDay,
    },

    props: {
        month: {
            type: String,
            required: true,
        },
        days: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
            default: 'check-in',
        },
        dateIn: {
            type: String,
            default: null,
        },
        dateOut: {
            type: String,
            default: null,
        },
        hoverDay: {
            type: Object,
            default: null,
        },
        showPrevMonthButton: {
            type: Boolean,
            default: false,
        },
        showNextMonthButton: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        monthLabel() {
            return dayjs(this.month).format('MMMM YYYY');
        },

        weeks() {
            return chunk(this.calDays, 7);
        },

        myDays() {
            return keyby(this.days, day => Number(day.date.substring(8, 10)));
        },

        calDays() {
            let day = dayjs(this.month).startOf('month');
            // pad start
            let days = Array(Number(day.format('d')));
            let end = dayjs(this.month).endOf('month');
            while (day.isBefore(end)) {
                days.push(this.myDays[day.format('D')] || null);
                day = day.add(1, 'day');
            }
            // pad end
            days.push(...Array(6 - Number(end.format('d'))));
            return days;
        },

        monthClasses() {
            return this.mode ? ('mode-' + this.mode) : '';
        },
    },

    watch: {
        days: {
            deep: true,
            handler() {
                console.debug('days changed for month', this.month)
            },
        },
    },

    methods: {
        yesterday(date) {
            let newDate = dayjs(date).subtract(1, 'day');
            return newDate ? this.days.find(day => day.date === newDate.format('YYYY-MM-DD')) : null;
        },

        tomorrow(date) {
            let newDate = dayjs(date).add(1, 'day');
            return newDate ? this.days.find(day => day.date === newDate.format('YYYY-MM-DD')) : null;
        },

        // forceUpdate() {
        //     console.debug('forceUpdate', this.monthLabel)
        //     this.$forceUpdate();
        //     console.debug(this.$refs);
        //     if (this.$refs['day-2024-06-22']) {
        //         this.$refs['day-2024-06-22'].$forceUpdate();
        //     }
        // },
    },
}
</script>

<style lang="scss">
.month-grid {
    *:not(i.fas) {
        font-family: Verdana, Arial, sans-serif;
    }
    .month {
        //display: flex;
        //flex-wrap: wrap;
        width: 80vw;
        max-width: 560px;
        margin: 10px auto;

        @media(max-width: 500px) {
            width: 98%;
        }
    }
    .prev-month i {
        margin: 0;
    }
    .month-label {
        flex: 0 0 100%;
        text-align: center;
        font-size: 1.3em;
        font-weight: bold;
    }
    .day-label {
        width: calc(100% / 7);
        text-align: center;
        font-size: clamp(0.7rem, -1.875rem + 8.333vw, 1.1rem);
        font-weight: bold;
    }
}
</style>
